import styled from "styled-components";
import {IonActionSheet} from "@ionic/react";

export const ActionsSheetComponent = styled(IonActionSheet)`
    --button-color: ${props => props.theme.colors.dark};
`
